"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
exports.__esModule = true;
exports.ACCEPTED_PAYMENT_GATEWAY_INSTITUTIONS = exports.PAYMENT_GATEWAYS = void 0;
exports.PAYMENT_GATEWAYS = {
    FINANS: {
        prettyName: 'Finansbank v2',
        institution: 'FINANS'
    },
    VAKIFBANK: {
        prettyName: 'Vakıfbank',
        institution: 'VAKIFBANK'
    },
    GARANTI: {
        prettyName: 'Garanti Bankası',
        institution: 'GARANTI'
    },
    YAPIKREDI: {
        prettyName: 'Yapıkredi Bankası',
        institution: 'YAPIKREDI'
    },
    IYZICO: {
        prettyName: 'Iyzico',
        institution: 'IYZICO'
    },
    DENIZBANK: {
        prettyName: 'Denizbank',
        institution: 'DENIZBANK'
    },
    ISBANK: {
        prettyName: 'İşbankası',
        institution: 'EST'
    },
    AKBANK: {
        prettyName: 'Akbank',
        institution: 'EST'
    },
    KUVEYTTURK: {
        prettyName: 'Kuveyttürk',
        institution: 'EST'
    },
    HALKBANK: {
        prettyName: 'Halkbank',
        institution: 'EST'
    },
    ANADOLUBANK: {
        prettyName: 'Anadolubank',
        institution: 'EST'
    },
    HSBC: {
        prettyName: 'Hsbc',
        institution: 'EST'
    },
    ZIRAATBANK: {
        prettyName: 'Ziraat Bankası',
        institution: 'EST'
    },
    FASTPAY: {
        prettyName: 'Fastpay',
        institution: 'FASTPAY'
    }
};
exports.ACCEPTED_PAYMENT_GATEWAY_INSTITUTIONS = __spread(new Set(Object.keys(exports.PAYMENT_GATEWAYS).map(function (gateway) { return exports.PAYMENT_GATEWAYS[gateway].institution; })));
//# sourceMappingURL=payment-gateway-templates.constants.js.map